import React from 'react'
import { Link } from 'gatsby'
import { Button } from '@arckit/ui'

const currentYear = new Date().getFullYear()

const Footer4 = () => {
	return (
		<footer id="footer" className=" bg-slate-800 pt-10">
			<div className="mx-auto flex flex-wrap pb-10 lg:max-w-screen-lg xl:max-w-screen-xl">
				<div className="mb-6 w-full lg:mb-0 lg:w-1/4">
					<div className="mx-auto max-w-max lg:max-w-full">
						<div className="mb-4">
							<img src="/images/logos/arc-logo-white-no-padding.svg" alt="arc logo" height={112} width={320} />
						</div>
						<div className="mb-4">
							<address className="text-center text-lg tracking-wide text-white lg:text-left">
								<span className="block">480 Norristown Rd.</span>
								<span>Blue Bell, PA 19422</span>
							</address>
						</div>
						<div className="flex justify-center gap-2 lg:justify-start">
							<a
								href="https://www.facebook.com/americanreading/"
								className="mr-2 flex items-center justify-center text-white hover:text-[#3b5998]"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="Visit our facebook profile"
							>
								<svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm3 8h-1.35c-.538 0-.65.221-.65.778v1.222h2l-.209 2h-1.791v7h-3v-7h-2v-2h2v-2.308c0-1.769.931-2.692 3.029-2.692h1.971v3z"
									/>
								</svg>
							</a>
							<a
								href="https://www.instagram.com/americanreading/"
								className="mr-2 flex items-center justify-center text-white hover:text-[#F6297A]"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="Visit our facebook profile"
							>
								<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16" className="h-5 w-5">
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"
									/>
								</svg>
							</a>

							<a
								href="https://twitter.com/AmericanReading"
								className="mr-2 flex items-center justify-center text-white hover:text-[#00acee]"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="Visit our twitter profile"
							>
								<svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"
									/>
								</svg>
							</a>
							<a
								href="https://www.linkedin.com/company/american-reading-company/"
								className="mr-2 flex items-center justify-center text-white hover:text-[#0e76a8]"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="Visit our linkedin profile"
							>
								<svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"
									/>
								</svg>
							</a>
							<a
								href="https://www.youtube.com/channel/UClr82wkKDNGNkDV9WfBszGg"
								className="flex items-center justify-center text-white hover:text-[#FF0000]"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="Visit our youtube page"
							>
								<svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"
									/>
								</svg>
							</a>
						</div>
					</div>
				</div>
				<div className="mb-6 w-full lg:mb-0 lg:w-1/2">
					<div className="mx-auto w-full px-4 sm:w-3/4 sm:px-0">
						<div className="flex flex-col justify-between text-white sm:flex-row">
							<div className="mb-10 flex flex-col gap-y-2 sm:mb-0">
								<Link to="/about-us" className="hover:text-white">
									<span className="text-white">About</span>
								</Link>
								<Link to="/connect" className="hover:text-white">
									<span className="text-white">Contact</span>
								</Link>
								<Link to="/contact-us" className="hover:text-white">
									<span className="text-white">Support</span>
								</Link>
								<Link to="/news" className="hover:text-white">
									<span className="text-white">News</span>
								</Link>
								<Link to="/state-reviews" className="hover:text-white">
									<span className="text-white">Impact</span>
								</Link>
								<Link to="/about-us" className="hover:text-white">
									<span className="text-white">Careers</span>
								</Link>
								<a href="https://info.americanreading.com/upcoming-webinar" className="hover:text-white" target="_blank">
									<span className="text-white">Events</span>
								</a>
								<Link to="/privacy-policy" className="hover:text-white">
									<span className="text-white">Privacy Policy</span>
								</Link>
								<Link to="/terms-of-use" className="hover:text-white">
									<span className="text-white">Terms of Use</span>
								</Link>
							</div>
							<div className="mb-10 flex flex-col gap-y-2 sm:mb-0">
								<Link to="/arc-core" className="hover:text-white">
									<span className="text-white">ARC Core</span>
								</Link>
								<Link to="/100-book-challenge" className="hover:text-white">
									<span className="text-white">100 Book Challenge</span>
								</Link>
								<Link to="/formative-assessment" className="hover:text-white">
									<span className="text-white">Assessment</span>
								</Link>
								<Link to="/digital-solutions" className="hover:text-white">
									<span className="text-white">Digital Solutions</span>
								</Link>
								<Link to="/themes" className="hover:text-white">
									<span className="text-white">Themes</span>
								</Link>
								<Link to="/libraries" className="hover:text-white">
									<span className="text-white">Libraries</span>
								</Link>
								<Link to="/summer" className="hover:text-white">
									<span className="text-white">Summer</span>
								</Link>
								<a href="https://quotes.americanreading.com" className="hover:text-white" target="_blank">
									<span className="text-white">Reorder</span>
								</a>
							</div>
							<div className="flex flex-col gap-y-2">
								<Link to="/state-reviews" className="hover:text-white">
									<span className="text-white">Impact</span>
								</Link>
								<Link to="/arc-press" className="hover:text-white">
									<span className="text-white">ARC Press</span>
								</Link>
								<Link to="/partnerships" className="hover:text-white">
									<span className="text-white">Partnerships</span>
								</Link>
								<Link to="/academic-advisory-council" className="hover:text-white">
									<span className="text-white">Advisory Council</span>
								</Link>
								<Link to="/professional-learning" className="hover:text-white">
									<span className="text-white">Professional Learning</span>
								</Link>
								<a href="https://forms.office.com/r/rraWrHyDPA" className="hover:text-white" target="_blank">
									<span className="text-white">ARC PD Feedback</span>
								</a>
								<a href="https://forms.office.com/r/wquDqZCApj" className="hover:text-white" target="_blank">
									<span className="text-white">ARC PD Sign-in</span>
								</a>
								<Link to="/login" className="hover:text-white">
									<span className="text-white">Core Adoption Sign-in</span>
								</Link>
							</div>
						</div>
					</div>
				</div>
				<div className="w-full lg:w-1/4">
					<Link to="/contact-us" className="hover:no-underline">
						<Button variant="secondary" fullWidth>
							Contact Us
						</Button>
					</Link>
				</div>
			</div>
			<div className="mx-auto border-b border-b-white lg:max-w-screen-lg xl:max-w-screen-xl" />
			<div>
				<div className="mx-auto flex flex-col items-center justify-between pt-3 pb-3 sm:flex-row lg:max-w-screen-lg xl:max-w-screen-xl">
					<div className="text-center text-sm md:text-left md:text-base">
						<span className="text-white">Copyright © {currentYear} American Reading Company. All rights reserved.</span>
					</div>
				</div>
			</div>
		</footer>
	)
}

export default Footer4
